import { selectors } from '@sloyd/store-base';
import { select } from 'saga-ts';

type params = {
  generatorId?: string;
  generator?: IGenerator;
  modelId?: string;
  model?: IModel;
};

export function* getIdAndName(params?: params) {
  let { generatorId, modelId, model, generator } = { ...params };

  try {
    if (!params) {
      model = yield* select(selectors.single.$currentModel);
    }

    if (modelId) {
      model = yield* select(selectors.single.$model, modelId);
    }

    if (model) {
      generatorId = model?.generatorId;
    }

    if (generatorId) {
      generator = yield* select(selectors.single.$generator, generatorId);
    }

    if (generator) {
      const { id, name } = generator;
      return {
        id,
        name,
      };
    }

    return {
      id: generatorId,
    };
  } catch (err) {
    return {
      id: generatorId,
    };
  }
}
